var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',[_vm._v("Profile Update")]),_vm._v("  ")]},proxy:true}])},[_c('ProfileUpdate')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }